import { useMemo } from 'react';

/**
 * Memoizes a StyleSheet factory, so styles are not recreated on every render.
 *
 * It deliberately does NOT re-run when the theme flips, and that is the seam
 * worth understanding. On web `Colors.role.*` resolves to `var()` strings
 * (`roleTokens.web.ts`): the generated class is static and the browser swaps
 * the value behind it when the `dark` class lands on `<html>`, so a
 * module-scope `StyleSheet.create` themes for free. On native there is no
 * runtime theme yet (plan 0028 scopes it out) and `Colors.role.*` is the
 * static light palette.
 *
 * When native theming lands, this is where mode-dependence would enter: the
 * factory would need `useThemeMode()` in its dependency list so the sheet is
 * rebuilt per mode. Web still would not - re-rendering on every flip is the
 * exact cost `var()` exists to avoid, which is why `useRoleHex` is reserved
 * for the few colour-math boundaries that cannot take a var().
 */
export function useThemedStyles<T>(styleCreator: () => T): T {
  return useMemo(() => styleCreator(), [styleCreator]);
}
